/**
 * Labstep
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import rules from 'labstep-web/services/validation/rules';
import { string } from 'yup';

export const COMPARISON_OPTIONS = [
  {
    label: 'Has value',
    value: PostFilterComparison.not_null,
  },
  {
    label: 'After',
    value: PostFilterComparison.gt,
  },
  {
    label: 'Before',
    value: PostFilterComparison.lt,
  },
];

export const fieldComparison: FieldWithoutActionProps = {
  fieldLabel: 'Comparison',
  name: 'comparison',
  fieldType: FieldType.ReactSelect,
  elementProps: {
    options: COMPARISON_OPTIONS.map((option) => ({
      value: option.value,
      label: option.label,
    })),
  },
  validation: rules.metadata.comparison,
};

export const fieldDate: FieldWithoutActionProps = {
  fieldLabel: 'Date',
  name: 'value',
  fieldType: FieldType.DateTimePicker,
  validation: string().required(),
};
